import { HumanReadableHelpHotline } from 'src/common/constants';
import { PhoneLink } from 'src/components/Typography/PhoneLink';
import { getPhoneNumber } from 'src/components/Typography/PhoneLink/utils/getPhoneNumber';

export const DefaultSubHeading = () => (
    <>
        Please try again later or call us at{' '}
        <PhoneLink {...getPhoneNumber(HumanReadableHelpHotline.CUSTOMER_EXPERIENCE)} /> with any questions about Zillow
        Home Loans, including updates on your loan application.
    </>
);
